"use client"

import React, { Component, ReactNode } from "react"

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class CopilotErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Debug: log no console para investigar erros do CopilotKit (filtrar por [Copilot])
    if (typeof window !== "undefined") {
      console.warn("[Copilot] CopilotErrorBoundary caught error, rendering fallback", {
        message: error.message,
        name: error.name,
        componentStack: errorInfo.componentStack?.slice(0, 200),
      })
    }
  }

  render() {
    if (this.state.hasError) {
      // Se houver um fallback customizado, use-o
      if (this.props.fallback) {
        if (typeof window !== "undefined") {
          console.warn("[Copilot] Rendering fallback (app without CopilotKit)")
        }
        return this.props.fallback
      }

      // Caso contrário, renderize os children sem CopilotKit
      // Isso permite que a aplicação continue funcionando mesmo quando o CopilotKit falha
      return <>{this.props.children}</>
    }

    return this.props.children
  }
}

